<template>
  <div class="gradient-button hit-cursor" 
  @click.stop="handleClick"
   :style="{width:width,height:height,border:border, color:color,background:background,lineHeight:height,fontSize:fontSize}">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "gradient-button",
  props: {
    width: {
      type: String,
      default:'100px' ,
    },
    height: {
      type: String,
      default:'40px' ,
    },
    fontSize: {
      type: String,
      default:'16px' ,
    },
    border:{
      type: String,
      default:'1px solid #578FFF' ,
    },
    color: {
      type: String,
      default:'#fff' ,
    },
    background: {
      type: String,
      default:'linear-gradient( 306deg, #578FFF 0%, #236CFF 100%)' ,
    },
  },
  methods:{
    handleClick(){
      this.$emit('hit')
    }
  }
};
</script>
<style lang="scss" scoped>
.gradient-button{
  border-radius: 4px 4px 4px 4px;
  text-align: center;
}
</style>